export default __webpack_public_path__ + "static/media/TikTok_Rounded.2f04d4dc.png";